import React from 'react'

import { MainHeader } from './MainHeader'
import { MobileHeader } from './MobileHeader'

import { App } from '@monorepo/hooks'
import logoImage from 'App/Resources/images/Logo_exclusive_small.png'

type HeaderPropsType = {
  //
}

export const Header: React.FC<HeaderPropsType> = () => {
  const { menu } = App.useMenu('main')

  return (
    <>
      <MainHeader logoImage={logoImage} menu={menu} />
      <MobileHeader logoImage={logoImage} menu={menu} />
    </>
  )
}
